export const SectorIds = {
    casualDating: 2007,
    gayDating: 2008,
    displayAd: 2009,
    transDating: 2815,
    kinkDating: 2816,
    camChat: 2817,
} as const

const categoryToSector: Record<string, number> = {
    "transen-shemale": SectorIds.transDating,
    "domina-sm": SectorIds.kinkDating,
}

const serviceFilterToSector: Record<string, number> = {
    dominant: SectorIds.kinkDating,
}

const pathSegmentToSector: Record<string, number> = {
    telefonsex: SectorIds.camChat,
    webcams: SectorIds.camChat,
    merkzettel: SectorIds.displayAd,
    fav: SectorIds.displayAd,
}

export function detectSectorFromUrl(pathname: string = location.pathname): number {
    const pathSegments = pathname.split("/").filter(Boolean)

    // Check for top-level path segments like /telefonsex or /webcams
    for (const segment of pathSegments) {
        if (segment in pathSegmentToSector) {
            return pathSegmentToSector[segment]
        }
    }

    // Find the sex-anzeigen segment and check the category after it
    const sexAnzeigenIndex = pathSegments.findIndex((segment) => segment === "sex-anzeigen")

    if (sexAnzeigenIndex !== -1) {
        const categorySegment = pathSegments[sexAnzeigenIndex + 1]

        if (categorySegment) {
            // Check for category matches (e.g., transen-shemale, domina-sm)
            // Categories can be comma-separated
            const categories = categorySegment.split(",")
            for (const category of categories) {
                if (category in categoryToSector) {
                    return categoryToSector[category]
                }
            }

            // Check for service filter matches (e.g., service:dominant)
            // Filters use semicolons between groups and colons for key:value
            const filterSegment = pathSegments[sexAnzeigenIndex + 2] ?? categorySegment
            const filterGroups = filterSegment.split(";")
            for (const group of filterGroups) {
                if (group.startsWith("service:")) {
                    const serviceValue = group.substring("service:".length)
                    const serviceValues = serviceValue.split(",")
                    for (const value of serviceValues) {
                        if (value in serviceFilterToSector) {
                            return serviceFilterToSector[value]
                        }
                    }
                }
            }
        }

        // Also check the segment after categories for filters
        const filterSegment = pathSegments[sexAnzeigenIndex + 2]
        if (filterSegment) {
            const filterGroups = filterSegment.split(";")
            for (const group of filterGroups) {
                if (group.startsWith("service:")) {
                    const serviceValue = group.substring("service:".length)
                    const serviceValues = serviceValue.split(",")
                    for (const value of serviceValues) {
                        if (value in serviceFilterToSector) {
                            return serviceFilterToSector[value]
                        }
                    }
                }
            }
        }
    }

    return SectorIds.casualDating
}
